import { ref } from 'vue'

export function useTaskUploadQueue() {
  const taskUploadQueue = ref<number[]>([])

  function enqueueTaskUploadId(id: number) {
    if (!taskUploadQueue.value.includes(id)) {
      taskUploadQueue.value.push(id)
    }
  }
  function dequeueTaskUploadId() {
    return taskUploadQueue.value.shift()
  }

  return {
    taskUploadQueue,
    enqueueTaskUploadId,
    dequeueTaskUploadId,
  }
}
